import ajax from '../ajax'


///api/setting/index
export function  ERPIndexApi(params) {
    return ajax({
        method:'get',
        url: 'api/setting/index',
        params
    })
}


// /api/setting/edit

export function  ERPEditApi(data) {
    return ajax({
        method:'post',
        url: 'api/setting/edit',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/basic_data/index.js